import { render, staticRenderFns } from "./DashboardCPM.vue?vue&type=template&id=39c96d0d&scoped=true"
import script from "./DashboardCPM.vue?vue&type=script&lang=js"
export * from "./DashboardCPM.vue?vue&type=script&lang=js"
import style0 from "./DashboardCPM.vue?vue&type=style&index=0&id=39c96d0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c96d0d",
  null
  
)

export default component.exports